import { fetchAPI } from '@/utils/useAPI'
import { Result, Err, Ok } from '@/classes'
import { Device } from '@capacitor/device'
import { Capacitor } from '@capacitor/core'

export const authPhoneRequestAPI = async (
	phone: string,
	params?: {
		isAlternate?: boolean
		isRegister?: boolean
	}
) => {
	let signals = {}

	if (Capacitor.isPluginAvailable('Device')) {
		const info = await Device.getInfo()
		const id = await Device.getId()

		signals = {
			device_id: id?.identifier ?? undefined,
			device_platform: Capacitor.getPlatform(),
			os_version: info.osVersion,
			device_model: info.model
		}
	}

	const response: Result<{
    success: boolean
	}> = await fetchAPI('auth/phone', { phone, signals, ...(params ?? {}) }, { method: 'POST' })

	return response
}

export const authPhoneValidateAPI = async (
  phone: string,
  code: string
) => {
	const response: Result<{
		token: string | null
	}> = await fetchAPI('auth/phone/validate', { phone, code }, { method: 'POST' })

	return response
}

export const authEmailRequestAPI = async (
	email: string,
	isRegister?: boolean
) => {
	const response: Result<{
    success: boolean
	}> = await fetchAPI('auth/email', { email, isRegister }, { method: 'POST' })

	return response
}

export const authEmailValidateAPI = async (
	email: string,
	code: string,
	params?: {
		token?: string
	}
) => {
	const response: Result<{
    token: string
	}> = await fetchAPI('auth/email/validate', { email, code, ...(params ?? {}) }, { method: 'POST' })

	return response
}

export const authCreateAPI = async (
	name: string,
	language: string,
	options?: {
		referral?: string
	}
) => {
	const response: Result<{
    token: string
	}> = await fetchAPI('auth/create', { name, language, options }, { method: 'POST' })

	return response
}

